const RESERVED_SUBDOMAINS = new Set(['www', 'app', 'api', 'admin']);
const BARE_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export default function getSubdomain() {
  const host = window.location.hostname;
  if (!host || BARE_HOSTS.has(host)) return undefined;

  const labels = host.split('.');

  const isLocalhostBased = labels[labels.length - 1] === 'localhost';
  const minLabels = isLocalhostBased ? 2 : 3;
  if (labels.length < minLabels) return undefined;

  const sub = labels[0].toLowerCase();
  if (RESERVED_SUBDOMAINS.has(sub)) return undefined;
  return sub;
}
